module.exports = __webpack_public_path__ + "static/media/ripp.98742a82.png";